import VirtualizedList from './VirtualizedList';

export default VirtualizedList;